<script>
  import { user } from "../../../stores/user";
  import { navigate } from "svelte-routing";
  import { panelController } from "../../../stores/service";
</script>

{#if $panelController.viewLogin.nav}
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
    <div class="col-sm-6">
      <!-- <h1>Collapsed Sidebar</h1> -->
    </div>
    <div class="col-sm-6">
      <ol class="breadcrumb float-sm-right">
      <!-- <li class="breadcrumb-item"><a href="#">Home</a></li>
      <li class="breadcrumb-item"><a href="#">Layout</a></li>
      <li class="breadcrumb-item active">Collapsed Sidebar</li> -->
      </ol>
    </div>
    </div>
  </div>

  </section>
{/if}